import { gql } from "@apollo/client";

export default gql`
  mutation RemoveComment($commentId: ObjectId!, $targetId: ObjectId) {
    removeComment(id: $commentId, targetId: $targetId)
  }
`;
